<app-breadcrumb [breadcrumb]="'My Profile'" [title]="'My Profile'"></app-breadcrumb>
<!-- section start -->
<section class="register-page section-b-space">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <h3>Update Profile</h3>
                <div class="theme-card">
                    <form #profileForm="ngForm" (ngSubmit)="profileForm.valid && updateProfile()" class="theme-form">
                        <div class="form-row">
                            <div class="col-md-4">
                                <label for="firstName">First Name*</label>
                                <input #firstName="ngModel" [(ngModel)]="editProfile.firstName" class="form-control"
                                       id="firstName" name="firstName" placeholder="First Name" required type="text">
                                <div *ngIf="firstName.errors && (firstName.dirty || firstName.touched || profileForm.submitted)"
                                     class="form-message">
                                    <span [hidden]="!firstName.errors.required" class="text-danger">This field is required.</span>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <label for="lastName">Last Name*</label>
                                <input #lastName="ngModel" [(ngModel)]="editProfile.lastName" class="form-control"
                                       id="lastName"
                                       name="lastName" placeholder="Last Name" required="" type="text">
                                <div *ngIf="lastName.errors && (lastName.dirty || lastName.touched || profileForm.submitted)"
                                     class="form-message">
                                    <span [hidden]="!lastName.errors.required" class="text-danger">This field is required.</span>
                                </div>
                            </div>
                            <div class="p-fluid p-grid p-formgrid">
                                <div class="p-field p-col-12">
                                    <label for="dob">Date of Birth*</label>
                                    <p-calendar #dob="ngModel" [(ngModel)]="dateOfBirth"
                                                [inputStyle]="'margin-bottom: 12px'" [monthNavigator]="true"
                                                [showIcon]="true" [yearNavigator]="true" id="dob"
                                                name="dob"
                                                placeholder="Select Date"
                                                required
                                                yearRange="{{startYear}}:{{currentYear}}"></p-calendar>
                                    <div *ngIf="dob.errors && (dob.dirty || dob.touched || profileForm.submitted)"
                                         class="form-message">
                                        <span [hidden]="!dob.errors.required" class="text-danger">This field is required.</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-md-4">
                                <label for="email">email*</label>
                                <input #emailId="ngModel" [(ngModel)]="editProfile.emailId" class="form-control"
                                       id="email"
                                       name="emailId" placeholder="Email" required type="text">
                                <div *ngIf="emailId.errors && (emailId.dirty || emailId.touched || profileForm.submitted)"
                                     class="form-message">
                  <span [hidden]="!emailId.errors.required" class="text-danger">
                    This field is required.
                  </span>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <label for="password">Password*</label>
                                <input #password="ngModel" [(ngModel)]="editProfile.password" class="form-control"
                                       id="password" name="password" placeholder="Enter your password" required
                                       type="password">
                                <div *ngIf="password.errors && (password.dirty || password.touched || profileForm.submitted)"
                                     class="form-message">
                  <span [hidden]="!password.errors.required" class="text-danger">
                    This field is required.
                  </span>
                                </div>
                            </div>

                        </div>
                        <div class="form-row">
                            <div class="col-md-3">
                                <label for="phNo">Phone Number*</label>
                                <input #mobileNo="ngModel" [(ngModel)]="editProfile.mobileNo" class="form-control"
                                       id="phNo" mask="9999999999"
                                       name="mobileNo" placeholder="Phone Number" required type="text">
                                <div *ngIf="mobileNo.errors && (mobileNo.dirty || mobileNo.touched || profileForm.submitted)"
                                     class="form-message">
                                    <span [hidden]="!mobileNo.errors.required" class="text-danger">
                                        This field is required.</span>
                                </div>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="field-label" for="gender">Gender*</label>
                                <select #gender="ngModel" [(ngModel)]="editProfile.gender" class="select-input"
                                        id="gender"
                                        name="gender"
                                        size="1">
                                    <option [value]="''">Select Gender</option>
                                    <option [value]="'Male'">Male</option>
                                    <option [value]="'Female'">Female</option>
                                </select>
                                <div *ngIf="(gender.errors || editProfile.gender === '') && (gender.touched || gender.dirty || profileForm.submitted)">
                  <span [hidden]="!gender.errors.required" class="text-danger">
                    This field is required.
                  </span>
                                </div>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col-md-4">
                                <label for="streetAddress1">Address Line One*</label>
                                <input #streetAddress1="ngModel" [(ngModel)]="editProfile.streetAddress1"
                                       class="form-control"
                                       id="streetAddress1" name="streetAddress1" placeholder="Address Line One" required
                                       type="text">
                                <div *ngIf="streetAddress1.errors && (streetAddress1.dirty || streetAddress1.touched || profileForm.submitted)"
                                     class="form-message">
                                    <span [hidden]="!streetAddress1.errors.required" class="text-danger">This field is required.</span>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <label for="streetAddress2">Address Line Two</label>
                                <input #streetAddress2="ngModel" [(ngModel)]="editProfile.streetAddress2"
                                       class="form-control"
                                       id="streetAddress2" name="streetAddress2" placeholder="Address Line Two" required
                                       type="text">
                                <div *ngIf="streetAddress2.errors && (streetAddress2.dirty || streetAddress2.touched || profileForm.submitted)"
                                     class="form-message">
                                    <span [hidden]="!streetAddress1.errors.required" class="text-danger">This field is required.</span>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <label for="city">City*</label>
                                <input #city="ngModel" [(ngModel)]="editProfile.city"
                                       class="form-control"
                                       id="city" name="city" placeholder="City" required
                                       type="text">
                                <div *ngIf="city.errors && (city.dirty || city.touched || profileForm.submitted)"
                                     class="form-message">
                                    <span [hidden]="!city.errors.required"
                                          class="text-danger">This field is required.</span>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <label for="state">State*</label>
                                <input #state="ngModel" [(ngModel)]="editProfile.state"
                                       class="form-control"
                                       id="state" name="state" placeholder="City" required
                                       type="text">
                                <div *ngIf="state.errors && (state.dirty || state.touched || profileForm.submitted)"
                                     class="form-message">
                                    <span [hidden]="!state.errors.required"
                                          class="text-danger">This field is required.</span>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <label for="country">Country*</label>
                                <input #country="ngModel" [(ngModel)]="editProfile.country"
                                       class="form-control"
                                       id="country" name="country" placeholder="Country" required
                                       type="text">
                                <div *ngIf="country.errors && (country.dirty || country.touched || profileForm.submitted)"
                                     class="form-message">
                                    <span [hidden]="!country.errors.required"
                                          class="text-danger">This field is required.</span>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <label for="pin">Pin Code*</label>
                                <input #pin="ngModel" [(ngModel)]="editProfile.pin"
                                       class="form-control"
                                       id="pin" name="pin" placeholder="Pin Code" required
                                       type="text">
                                <div *ngIf="pin.errors && (pin.dirty || pin.touched || profileForm.submitted)"
                                     class="form-message">
                                    <span [hidden]="!pin.errors.required"
                                          class="text-danger">This field is required.</span>
                                </div>
                            </div>
                        </div>

                        <button class="btn btn-solid">Update Profile</button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</section>
<!--Section ends-->
